const URL_BASE=process.env.REACT_APP_API;

export const URL_PACK_STATUS_LIST=`${URL_BASE}/packStatus`;